import React, { useEffect } from 'react';
import './Process.css';
import { useGlobalScrollAnimation } from '../hooks/useGlobalScrollAnimation';

const ProcessPage = () => {
  const { animatedSections } = useGlobalScrollAnimation();

  const handleBackToHome = () => {
    window.history.pushState({}, '', '/');
    window.dispatchEvent(new PopStateEvent('popstate'));
  };

  // Trigger animations immediately when component mounts
  useEffect(() => {
    const triggerAnimations = () => {
      const progressiveElements = document.querySelectorAll('.progressive-element');
      progressiveElements.forEach((element, index) => {
        setTimeout(() => {
          element.classList.add('loaded');
          element.classList.remove('unloaded');
        }, index * 100);
      });
      
      const dynamicElements = document.querySelectorAll('.dynamic-content');
      dynamicElements.forEach((element) => {
        element.classList.add('loaded');
        element.classList.remove('unloaded');
      });
    };

    // Trigger animations after a short delay to ensure DOM is ready
    setTimeout(triggerAnimations, 100);
  }, []);

  const steps = [
    {
      number: 1,
      title: 'הצהרת בריאות',
      description: 'לפני שמתחילים בכלל את תהליך לימוד הנהיגה צריך קודם להוציא הצהרת בריאות באתר של משרד הרישוי, תמלאו אותו והמשיכו לשלב הבא',
      link: 'https://govforms.gov.il/mw/forms/RishumTheory@mot.gov.il?gbxid=1'
    },
    {
      number: 2,
      title: 'בדיקת ראייה',
      description: 'לאחר מילוי הצהרת בריאות אתם צריכים ללכת להוציא טופס ירוק בתחנת צילום עבורכם במיוחד הוספתי לינק שבו תוכלו למצוא את כל התחנות צילום באיזור',
      link: 'https://www.gov.il/he/Departments/DynamicCollectors/photo_driving_license_stock?skip=0&l'
    },
    {
      number: 3,
      title: 'מבחן הנהיגה העיוני - תיאוריה',
      description: 'עכשיו אתם מוכנים לגשת למבחן התיאוריה, זהו המבחן הראשון שתעברו בדרך לרישיון הנהיגה. אני אעזור לכם להתכונן בצורה הטובה ביותר',
      link: 'https://www.theorytest.org.il/branches/'
    },
    {
      number: 4,
      title: 'מתחילים ללמוד',
      description: 'אחרי שעברתם את מבחן התיאוריה, אנחנו מתחילים את השיעורים המעשיים. אני אתאים את קצב הלימוד לרמה שלכם ואבטיח שתהיו מוכנים למבחן המעשי',
      link: 'https://alpha-ps.com/Client/HTML/SchoolSettings/Payment_Pages/school-payment.html?State=1%26paymentPages_Id=285'
    },
    {
      number: 5,
      title: 'תשלום אגרת טסט חיצוני (מבחן מעשי)',
      description: 'לפני הגשת המבחן המעשי, יש לשלם את אגרת הטסט החיצוני. זהו התשלום עבור המבחן המעשי עצמו',
      link: 'https://ecom.gov.il/voucherspa/input/427'
    },
    {
      number: 6,
      title: 'תשלום רשיון (לאחר הצלחה במבחן המעשי)',
      description: 'לאחר שעברתם בהצלחה את המבחן המעשי, יש לשלם את אגרת הרשיון כדי לקבל את רישיון הנהיגה',
      link: 'https://ecom.gov.il/voucherspa/input/209'
    }
  ];

  return (
    <div className="process-page">
      <section id="process" className="section process">
        <div className="container">
          <div className="process-header">
            <button onClick={handleBackToHome} className="back-button">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                <path d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z"/>
              </svg>
              חזרה לעמוד הבית
            </button>
            <h2 className="section-title progressive-element">המסלול הפשוט ביותר לרישיון</h2>
            <h4 className="process-subtitle progressive-element">כל הלינקים וכל השלבים במקום אחד</h4>
          </div>
          
          <div className="process-steps">
            {steps.map((step, index) => (
              <div key={index} className="process-step progressive-element stagger-1">
                <div className="step-number">
                  {step.number}
                </div>
                <div className="step-content">
                  <h3 className="step-title">{step.title}</h3>
                  <p className="step-description">{step.description}</p>
                  {step.link !== '#' && (
                    <a href={step.link} target="_blank" rel="noopener noreferrer" className="step-link">
                      {step.number === 1 && "להצהרת הבריאות"}
                      {step.number === 2 && "לתחנות צילום"}
                      {step.number === 3 && "זימון למבחן תיאוריה"}
                      {step.number === 4 && "התחל ללמוד"}
                      {step.number === 5 && "תשלום אגרת טסט חיצוני"}
                      {step.number === 6 && "תשלום רשיון"}
                    </a>
                  )}
                </div>
              </div>
            ))}
          </div>
          
          <div className="process-cta dynamic-content">
            <div className="cta-card">
              <h3>מאמין בכם - אל תעכבו את הרישיון - התחילו עוד היום!</h3>
              <p>לכל שאלה התקשרו או שלחו הודעה אני כאן!</p>
              <a href="#contact" className="btn">
                התחל עכשיו
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ProcessPage;
